import { SvgIcon, SvgIconProps } from '@mui/material';
export const SignOutIcon = (props: SvgIconProps) => (
  <SvgIcon width="28" height="28" viewBox="0 0 28 28" {...props}>
    <path
      d="M5.25 3.5625H11.375C11.5905 3.5625 11.7968 3.64841 11.9492 3.80078C12.1016 3.95315 12.1875 4.15951 12.1875 4.375C12.1875 4.59049 12.1016 4.79685 11.9492 4.94922C11.7968 5.10159 11.5905 5.1875 11.375 5.1875H5.1875V22.8125H11.375C11.5905 22.8125 11.7968 22.8984 11.9492 23.0508C12.1016 23.2032 12.1875 23.4095 12.1875 23.625C12.1875 23.8405 12.1016 24.0468 11.9492 24.1992C11.7968 24.3516 11.5905 24.4375 11.375 24.4375H5.25C4.80245 24.4375 4.37311 24.2598 4.05664 23.9434C3.74017 23.6269 3.5625 23.1976 3.5625 22.75V5.25C3.5625 4.80245 3.74017 4.37311 4.05664 4.05664C4.37311 3.74017 4.80245 3.5625 5.25 3.5625Z"
      fill="white"
      stroke="white"
      strokeWidth="0.125"
    />
    <path d="M11 14H23" stroke="white" strokeWidth="2" strokeLinecap="round" />
    <path
      d="M19 10L23 14L19 18"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
